import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BookmarksService } from '../service/bookmarks.service';
import * as BookmarksActions from './bookmarks.actions';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { forkJoin } from 'rxjs';

@Injectable()
export class BookmarksEffects {
  private actions$ = inject(Actions);
  private bookmarksService = inject(BookmarksService);

  setBookmark$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BookmarksActions.setBookmark),
      switchMap(({ documentId }) =>
        this.bookmarksService.setBookmark(documentId).pipe(
          map((response) => BookmarksActions.setBookmarkSuccess({ response })),
          catchError((error) => of(BookmarksActions.setBookmarkFailure({ error: { ...error, documentId } }))),
        ),
      ),
    ),
  );

  deleteBookmark$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BookmarksActions.deleteBookmark),
      switchMap(({ documentId }) =>
        this.bookmarksService.deleteBookmark(documentId).pipe(
          map((response) => BookmarksActions.deleteBookmarkSuccess({ response })),
          catchError((error) => of(BookmarksActions.deleteBookmarkFailure({ error: { ...error, documentId } }))),
        ),
      ),
    ),
  );

  deleteBookmarks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BookmarksActions.deleteBookmarks),
      mergeMap(({ documentIds }) =>
        (documentIds.length > 0
          ? forkJoin(documentIds.map((documentId) => this.bookmarksService.deleteBookmark(documentId)))
          : of([])
        ).pipe(
          map(() => BookmarksActions.deleteBookmarksSuccess({ documentIds })),
          catchError((error) => of(BookmarksActions.deleteBookmarksFailure({ documentIds, error }))),
        ),
      ),
    ),
  );
}
